var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowDatepicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#383838"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.168 13.762l5.577-5.812c.633-.66 1.68-.68 2.339-.048l.048.048.072.075c.626.653.626 1.684 0 2.337l-4.39 4.572 4.39 4.574c.59.614.624 1.564.104 2.218l-.104.119-.072.075-.048.048c-.66.632-1.706.61-2.339-.048l-5.577-5.812c-.295-.308-.451-.699-.468-1.095v-.157c.017-.396.173-.787.468-1.094z",
    transform: "translate(-1042.000000, -375.000000) translate(324.000000, 176.000000) translate(424.000000, 199.000000) translate(309.373374, 15.000000) scale(-1, 1) translate(-309.373374, -15.000000) translate(294.373374, -0.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowDatepicker);
export default __webpack_public_path__ + "static/media/right-arrow-datepicker.fd97d41c746f744e058e15d382094e0f.svg";
export { ForwardRef as ReactComponent };